"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diagnosis = exports.modifiers = exports.procedureCode = exports.chargeSessionCodes = void 0;
var chargeSessionCodes = [
    {
        fieldDefinitions: [
            { label: "Procedure", value: "CPT", key: "CPT", disabled: false },
            { label: "Diagnosis", value: "ICD", key: "ICD" },
            { label: "Modifier", value: "MODIFIER", key: "MODIFIER" }
        ],
        chargeType: "professional",
        providers: [
            {
                provider: {
                    name: "null",
                    number: { number: "1522089", issuer: "EPIC", type: "EPIC" }
                },
                providerRole: "billing_provider"
            }
        ],
        billingInformation: { billingLocation: "MGHMC", billingArea: "some" },
        codes: [
            {
                codeType: "diagnosis",
                provenance: "ICD",
                code: "Z46.82",
                units: 0,
                unitable: false,
                editable: true,
                hash: "something",
                description: "Encounter for fitting and adjustment of non-vascular catheter",
                codeIssues: [],
                evidence: [
                    {
                        linkable: true,
                        displayable: true,
                        selectionState: { active: false, hover: false, visible: false },
                        featureType: "complete",
                        identifier: "83600e24-5170-455f-8f5d-5bc14088eddb",
                        fieldName: "procedure_category",
                        fieldIdentifier: "83600e24-5170-455f-8f5d-5bc14088eddb",
                        meta: { content: "XRAY" }
                    },
                    {
                        linkable: true,
                        displayable: true,
                        selectionState: { active: false, hover: false, visible: false },
                        featureType: "complete",
                        identifier: "3c7142f8-0c05-4e85-bd8d-84db9c7718e8",
                        fieldName: "procedure_type",
                        fieldIdentifier: "3c7142f8-0c05-4e85-bd8d-84db9c7718e8",
                        meta: { content: "Digital Radiography" }
                    },
                    {
                        linkable: false,
                        displayable: true,
                        selectionState: { active: false, hover: false, visible: false },
                        featureType: "complete",
                        identifier: "1eb29828-cbe6-45b3-933a-e637ae1e4191",
                        fieldName: "reason_for_visit",
                        fieldIdentifier: "1eb29828-cbe6-45b3-933a-e637ae1e4191",
                        meta: null
                    },
                    {
                        linkable: true,
                        displayable: true,
                        selectionState: { active: false, hover: false, visible: false },
                        featureType: "complete",
                        identifier: "94d8bb70-0651-478d-92ea-b50dad3b31c2",
                        fieldName: "body_region",
                        fieldIdentifier: "94d8bb70-0651-478d-92ea-b50dad3b31c2",
                        meta: { content: "Abdomen" }
                    },
                    {
                        linkable: true,
                        displayable: true,
                        selectionState: { active: false, hover: false, visible: false },
                        featureType: "partial",
                        identifier: "2a16ab75-82d8-4146-8377-301d77fabc90",
                        fieldName: "raw_body",
                        fieldIdentifier: "2a16ab75-82d8-4146-8377-301d77fabc90",
                        meta: {
                            start: 109,
                            end: 184,
                            level: "sentence",
                            content: " An enteric tube is appropriately positioned in the mid to distal stomach. ",
                            identifier: "824eb884-4e4e-4aef-917a-6e46887ee923"
                        }
                    }
                ]
            }
        ],
        transactionId: "061940d4-cfe0-40f1-ad35-69ab7da1bd3a",
        transactionType: "ASSEMBLED",
        invoiceId: "57bb9dc4-d20f-4a57-b2ef-51191c3ec902",
        processInstanceId: "22773"
    }
];
exports.chargeSessionCodes = chargeSessionCodes;
var procedureCode = [
    {
        codeType: "procedure",
        provenance: "CPT",
        code: "J3471",
        units: 1,
        unitable: true,
        editable: true,
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701__J3471",
        codeIssues: [],
        evidence: [],
        description: "Ovine, up to 999 usp units"
    }
];
exports.procedureCode = procedureCode;
var modifiers = [
    {
        codeType: "modifier",
        provenance: "MODIFIER",
        code: "AB",
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701:AB",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        evidence: [],
        description: "Aud svs w/o order evry 12mo"
    },
    {
        codeType: "modifier",
        provenance: "MODIFIER",
        code: "HG",
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701:HG",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        evidence: [],
        description: "Opioid addiction treatment program"
    },
    {
        codeType: "modifier",
        provenance: "MODIFIER",
        code: "UH",
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701:UH",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        evidence: [],
        description: "Services provided in the evening"
    }
];
exports.modifiers = modifiers;
var diagnosis = [
    {
        codeType: "diagnosis",
        provenance: "ICD",
        code: "B68.1",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701__B68__1",
        evidence: [],
        description: "Taenia saginata taeniasis"
    },
    {
        codeType: "diagnosis",
        provenance: "ICD",
        code: "I85.01",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701__I85__01",
        evidence: [],
        description: "Esophageal varices with bleeding"
    },
    {
        codeType: "diagnosis",
        provenance: "ICD",
        code: "K65.1",
        units: 0,
        unitable: false,
        editable: true,
        codeIssues: [],
        hash: "05a08242-e60a-4721-a0fe-8379cf7cb701__K65__1",
        evidence: [],
        description: "Peritoneal abscess"
    }
];
exports.diagnosis = diagnosis;
//# sourceMappingURL=charge-session-codes.js.map